<new-flowbanner [showPromo]="true"></new-flowbanner>
<div class="pb-5 pb-lg-5 feedback-container">
    <div class="row justify-content-center me-0">
        <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
            <img class="feedback-image" src="./assets/img/check-the-information.png" width="500" height="320"
                alt="Ilustración de verificación de información." loading="lazy" />

            <h2 class="feedback-title">¡Verifica la información!</h2>
            <p class="feedback-subtitle">
                Hemos notado que algunos de los datos que proporcionaste podrían no estar correctos.
            </p>
            <p class="feedback-text">
                Revisa la información y asegúrate de que todo esté bien para que podamos avanzar con tu cotización.
            </p>

            <button (click)="retry()" type="button"
                class="btn btn-primary btn-lg rounded-pill sura-feedback-btn mb-5">
                Entendido
            </button>
        </div>
    </div>
</div>

<app-footer-app></app-footer-app>
